module.exports = __webpack_public_path__ + "img/第8章_3-1_賴和面具背面紙條.png";